// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-module--header--291GF","headerContainer":"Header-module--header-container--H9OEf","title":"Header-module--title--1PorR","logo":"Header-module--logo--3hltD"};